<style lang="less">
    @import "./vip.less";
</style>
<template>
    <div class="vipparent">
        <div class="vip_background">
            <div class="vip_back_img_content">
                <div class="img_con">
                    <img src="../../../assets/vip_background.png" alt='版权登记'/>
                    <div class="img_con_fi">
                        <p></p>
                        <p class="img_vip">VIP</p>
                        <p></p>
                    </div>
                    <div class="img_con_se">
                        <p>会员专享特权</p>
                        <p>全面保护版权</p>
                    </div>
                    <div class="img_con_th">
                        COPYRIGHT PROTECTION
                    </div>
                </div>
            </div>
        </div>
        <div class="vip_content">
            <div class="vip_cont_title">
                <div>成为VIP会员立享以下特权</div>
                <p></P>
            </div>
            <div class="vip_cont_content">
                <div class="vip_cont_kpay">
                    <div v-for="(item,index) in showKtList" :key="index"
                         :class="{'vip_cont_subpay':true, 'vip_cont_subpay_1':index==0,'vip_cont_subpay_2':index==1,'vip_cont_subpay_3':index==2}">
                        <img class="vip_cont_subpay_icon" :src="item.url" alt='版权登记'/>
                        <div :class="{'color_1':index==0,'color_2':index==1,'color_3':index==2}">
                            <p>{{item.title.replace('用户','')}}</p>
                            <p style="width:100%">￥{{item.value}}/年</p>
                        </div>
                        <input type="button" @click="goSy(item)" :value="showText"/>
                    </div>
                </div>
                <div class="vip_cont_autopay" style="visibility:hidden">
                    <input type="checkbox"/>
                    <p>开通自动续费，到期后由版权家自动从您支付账户进行扣款</p>
                </div>
                <div class="vip_cont_table">
                    <Row class-name="rowtitle">
                        <Col class-name="coltitle" span="12">VIP尊享特权</Col>
                        <Col class-name="coltime" v-for="(item,index) in vipList" :key="index"
                             :span="Math.floor(12/vipList.length)==0?1:Math.floor(12/vipList.length)">{{item.title}}
                        </Col>
                    </Row>

                    <Row v-show="vipList[0].registerVipRights.evidenceArchiveNum!=0 || vipList[0].registerVipRights.copyrightRegisterNum!=0 || vipList[0].registerVipRights.paperCopyrightRegisterNum!=0 || vipList[0].registerVipRights.copyrightRegisterFindNum!=0 || vipList[0].registerVipRights.copyrightRegisterCancelNum!=0 || vipList[0].registerVipRights.copyrightRegisterUpdateNum!=0"
                         class-name="rowcolor">
                        <Col span="24" class-name="colcommonContent">
                            <div>1</div>
                            <p>在线快速确权</p>
                        </Col>
                    </Row>
                    <Row v-show="vipList[0].registerVipRights.evidenceArchiveNum && vipList[0].registerVipRights.evidenceArchiveNum!=0"
                         class-name="rowsubtitle">
                        <Col class-name="colsubtitle" span="12">
                            <div>
                                <p>版权存证</p>
                                <p>提供原创作品证明和内容确认。由工信部认可的版权区块链来记录作者及作品信息。内容都可进行核验</p>
                            </div>
                        </Col>
                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index"
                             :span="Math.floor(12/vipList.length)==0?1:Math.floor(12/vipList.length)">
                            {{item.registerVipRights.evidenceArchiveNum}}次
                        </Col>
                    </Row>
                    <Row v-show="vipList[0].registerVipRights.copyrightRegisterNum && vipList[0].registerVipRights.copyrightRegisterNum!=0"
                         class-name="rowsubtitle">
                        <Col class-name="colsubtitle" span="12">
                            <div>
                                <p>电子版权登记</p>
                                <p>在线申请版权局颁发的电子版权登记证书</p>
                            </div>
                        </Col>
                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index"
                             :span="Math.floor(12/vipList.length)==0?1:Math.floor(12/vipList.length)">
                            {{item.registerVipRights.copyrightRegisterNum}}次
                        </Col>
                    </Row>
                    <Row v-show="vipList[0].registerVipRights.paperCopyrightRegisterNum && vipList[0].registerVipRights.paperCopyrightRegisterNum!=0"
                         class-name="rowsubtitle">
                        <Col class-name="colsubtitle" span="12">
                            <div>
                                <p>纸质版权登记</p>
                                <p>在线申请版权局颁发的纸质版权登记证书</p>
                            </div>
                        </Col>
                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index"
                             :span="Math.floor(12/vipList.length)==0?1:Math.floor(12/vipList.length)">
                            {{item.registerVipRights.paperCopyrightRegisterNum}}次
                        </Col>
                    </Row>
                    <Row v-show="vipList[0].registerVipRights.copyrightRegisterFindNum && vipList[0].registerVipRights.copyrightRegisterFindNum!=0"
                         class-name="rowsubtitle">
                        <Col class-name="colsubtitle" span="12">
                            <div>
                                <p>证书查询</p>
                                <p>证书信息查询服务</p>
                            </div>
                        </Col>
                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index"
                             :span="Math.floor(12/vipList.length)==0?1:Math.floor(12/vipList.length)">
                            {{item.registerVipRights.copyrightRegisterFindNum}}次
                        </Col>
                    </Row>
                    <Row v-show="vipList[0].registerVipRights.copyrightRegisterCancelNum && vipList[0].registerVipRights.copyrightRegisterCancelNum!=0"
                         class-name="rowsubtitle">
                        <Col class-name="colsubtitle" span="12">
                            <div>
                                <p>证书撤销</p>
                                <p>证书信息撤销服务</p>
                            </div>
                        </Col>
                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index"
                             :span="Math.floor(12/vipList.length)==0?1:Math.floor(12/vipList.length)">
                            {{item.registerVipRights.copyrightRegisterCancelNum}}次
                        </Col>
                    </Row>
                    <Row v-show="vipList[0].registerVipRights.copyrightRegisterUpdateNum && vipList[0].registerVipRights.copyrightRegisterUpdateNum!=0"
                         class-name="rowsubtitle">
                        <Col class-name="colsubtitle" span="12">
                            <div>
                                <p>作品变更</p>
                                <p>作品信息变更服务</p>
                            </div>
                        </Col>
                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index"
                             :span="Math.floor(12/vipList.length)==0?1:Math.floor(12/vipList.length)">
                            {{item.registerVipRights.copyrightRegisterUpdateNum}}次
                        </Col>
                    </Row>

                    <Row v-show="vipList[0].registerVipRights.imageMonitorNum!=0 || vipList[0].registerVipRights.imageMonitorNum!=0 || vipList[0].registerVipRights.musicMonitorNum!=0 || vipList[0].registerVipRights.textMonitorNum!=0"
                         class-name="rowcolor">
                        <Col span="24" class-name="colcommonContent">
                            <div>2</div>
                            <p>实时监测作品传播范围</p>
                        </Col>
                    </Row>
                    <Row v-show="vipList[0].registerVipRights.imageMonitorNum" class-name="rowsubtitle">
                        <Col class-name="colsubtitle" span="12">
                            <div>
                                <p>图片监测</p>
                                <p>高准确度、操作简便，实时反馈监测结果</p>
                            </div>
                        </Col>
                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index"
                             :span="Math.floor(12/vipList.length)==0?1:Math.floor(12/vipList.length)">
                            {{item.registerVipRights.imageMonitorNum}}次
                        </Col>
                    </Row>
                    <Row v-show="vipList[0].registerVipRights.musicMonitorNum" class-name="rowsubtitle">
                        <Col class-name="colsubtitle" span="12">
                            <div>
                                <p>音乐监测</p>
                                <p>高准确度、操作简便，实时反馈监测结果</p>
                            </div>
                        </Col>
                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index"
                             :span="Math.floor(12/vipList.length)==0?1:Math.floor(12/vipList.length)">
                            {{item.registerVipRights.musicMonitorNum}}次
                        </Col>
                    </Row>
                    <Row v-show="vipList[0].registerVipRights.textMonitorNum" class-name="rowsubtitle">
                        <Col class-name="colsubtitle" span="12">
                            <div>
                                <p>文字监测</p>
                                <p>高准确度、操作简便，实时反馈监测结果</p>
                            </div>
                        </Col>
                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index"
                             :span="Math.floor(12/vipList.length)==0?1:Math.floor(12/vipList.length)">
                            {{item.registerVipRights.textMonitorNum}}次
                        </Col>
                    </Row>
                    <Row v-show="(vipList[0].registerVipRights.imageMonitorNum) + (vipList[0].registerVipRights.musicMonitorNum) + (vipList[0].registerVipRights.textMonitorNum) !=0"
                         class-name="rowsubtitle">
                        <Col class-name="colsubtitle" span="12">
                            <div>
                                <p>下载监听报告</p>
                                <p>可全方位了解侵权线索、下载pdf格式的监听报告</p>
                            </div>
                        </Col>
                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index"
                             :span="Math.floor(12/vipList.length)==0?1:Math.floor(12/vipList.length)">
                            {{item.registerVipRights.imageMonitorNum + item.registerVipRights.musicMonitorNum +
                            item.registerVipRights.textMonitorNum}}次
                        </Col>
                    </Row>

                    <Row v-show="vipList[0].registerVipRights.forensicsNum!=0" class-name="rowcolor">
                        <Col span="24" class-name="colcommonContent">
                            <div>2</div>
                            <p>司法可信的区块链取证</p>
                        </Col>
                    </Row>
                    <Row v-show="vipList[0].registerVipRights.forensicsNum && vipList[0].registerVipRights.forensicsNum!=0"
                         class-name="rowsubtitle">
                        <Col class-name="colsubtitle" span="12">
                            <div>
                                <p>版权取证</p>
                                <p>中国科学院国家授时中心可信授时，版权区块链，准确，不可修改性，取证司法认可</p>
                            </div>
                        </Col>
                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index"
                             :span="Math.floor(12/vipList.length)==0?1:Math.floor(12/vipList.length)">
                            {{item.registerVipRights.forensicsNum}}次
                        </Col>
                    </Row>

                    <Row v-show="vipList[0].registerVipRights.notarizationNum!=0" class-name="rowcolor">
                        <Col span="24" class-name="colcommonContent">
                            <div>4</div>
                            <p>公证</p>
                        </Col>
                    </Row>
                    <Row v-show="vipList[0].registerVipRights.notarizationNum && vipList[0].registerVipRights.notarizationNum!=0"
                         class-name="rowsubtitle">
                        <Col class-name="colsubtitle" span="12">
                            <div>
                                <p>电子数据确认函</p>
                                <p>基于可靠信息和安全技术的公证服务</p>
                            </div>
                        </Col>
                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index"
                             :span="Math.floor(12/vipList.length)==0?1:Math.floor(12/vipList.length)">
                            {{item.registerVipRights.notarizationNum}}次
                        </Col>
                    </Row>

                    <Row v-show="vipList[0].registerVipRights.lawyerConsult30Num!=0 || vipList[0].registerVipRights.lawyerConsult60Num!=0 || vipList[0].registerVipRights.lawyerLetterNum!=0 || vipList[0].registerVipRights.tortShelvesNum!=0 || vipList[0].registerVipRights.contractAuditNum!=0 || vipList[0].registerVipRights.infringementDeterminationNum!=0"
                         class-name="rowcolor">
                        <Col span="24" class-name="colcommonContent">
                            <div>3</div>
                            <p>便捷、有效的互联网法律维权服务</p>
                        </Col>
                    </Row>
                    <Row v-show="vipList[0].registerVipRights.lawyerConsult30Num && vipList[0].registerVipRights.lawyerConsult30Num!=0"
                         class-name="rowsubtitle">
                        <Col class-name="colsubtitle" span="12">
                            <div>
                                <p>电话问律师30分钟</p>
                                <p>合作律师所200+，覆盖各大主要城市，年维权案件落地13500+，专业法务团队35人+月处理案件2800件+</p>
                            </div>
                        </Col>
                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index"
                             :span="Math.floor(12/vipList.length)==0?1:Math.floor(12/vipList.length)">
                            {{item.registerVipRights.lawyerConsult30Num}}次
                        </Col>
                    </Row>
                    <Row v-show="vipList[0].registerVipRights.lawyerConsult60Num && vipList[0].registerVipRights.lawyerConsult60Num!=0"
                         class-name="rowsubtitle">
                        <Col class-name="colsubtitle" span="12">
                            <div>
                                <p>电话问律师60分钟</p>
                                <p>合作律师所200+，覆盖各大主要城市，年维权案件落地13500+，专业法务团队35人+月处理案件2800件+</p>
                            </div>
                        </Col>
                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index"
                             :span="Math.floor(12/vipList.length)==0?1:Math.floor(12/vipList.length)">
                            {{item.registerVipRights.lawyerConsult60Num}}次
                        </Col>
                    </Row>
                    <Row v-show="vipList[0].registerVipRights.lawyerLetterNum && vipList[0].registerVipRights.lawyerLetterNum!=0"
                         class-name="rowsubtitle" style="height:86px">
                        <Col class-name="colsubtitle" span="12">
                            <div>
                                <p>出具律师函</p>
                                <p style="margin-bottom:0px">由版权家合作或自营律师事务所为您开具具有法律效力的法律函</p>
                            </div>
                        </Col>
                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index"
                             :span="Math.floor(12/vipList.length)==0?1:Math.floor(12/vipList.length)">
                            {{item.registerVipRights.lawyerLetterNum}}次
                        </Col>
                    </Row>
                    <Row v-show="vipList[0].registerVipRights.tortShelvesNum && vipList[0].registerVipRights.tortShelvesNum!=0"
                         class-name="rowsubtitle" style="height:86px">
                        <Col class-name="colsubtitle" span="12">
                            <div>
                                <p>侵权下架</p>
                                <p style="margin-bottom:0px">精英律师顾问团为您的创业之路保驾护航</p>
                            </div>
                        </Col>
                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index"
                             :span="Math.floor(12/vipList.length)==0?1:Math.floor(12/vipList.length)">
                            {{item.registerVipRights.tortShelvesNum}}次
                        </Col>
                    </Row>
                    <Row v-show="vipList[0].registerVipRights.contractAuditNum && vipList[0].registerVipRights.contractAuditNum!=0"
                         class-name="rowsubtitle" style="height:86px">
                        <Col class-name="colsubtitle" span="12">
                            <div>
                                <p>合同审核</p>
                                <p style="margin-bottom:0px">专业律师为您起草或审核合同，规避法律风险</p>
                            </div>
                        </Col>
                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index"
                             :span="Math.floor(12/vipList.length)==0?1:Math.floor(12/vipList.length)">
                            {{item.registerVipRights.contractAuditNum}}次
                        </Col>
                    </Row>
                    <Row v-show="vipList[0].registerVipRights.infringementDeterminationNum && vipList[0].registerVipRights.infringementDeterminationNum!=0"
                         class-name="rowsubtitle" style="height:86px">
                        <Col class-name="colsubtitle" span="12">
                            <div>
                                <p>侵权判定+维权方案设计</p>
                                <p style="margin-bottom:0px">专业律师为您判定侵权、分析证据制定最优维权方案</p>
                            </div>
                        </Col>
                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index"
                             :span="Math.floor(12/vipList.length)==0?1:Math.floor(12/vipList.length)">
                            {{item.registerVipRights.infringementDeterminationNum}}次
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
        <myPay :subBizType="subBizTypesb" :payMoney="payMoney" @fatherModal="fatherModal" @updatePayTxt="updatePayTxt"
               mywidth='766' myheight="425" myTitleheight="50" v-if="showModal"/>
        <mycapay @fatherModal="fatherModal" mywidth='838' myheight="585" myTitleheight="50" v-if="showModal02"/>
    </div>
</template>

<script>
    import myPay from './lawcomponent/mypay.vue'
    import Cookies from "js-cookie";
    import {goPersonOrEnterVip} from '@/api/staticPage';
    import {userInfo, _findIndexPageShowNewNew} from "@/api/index";
    import mycapay from './lawcomponent/myczpay.vue';

    export default {
        metaInfo: {
            title: 'VIP会员|版权服务专家|版权家',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            }, {
                name: 'Description',
                content: '个人VIP会员,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name: 'vipone',
        components: {
            myPay,
            mycapay
        },
        data() {
            return {
                vipList: [],
                showKtList: [],
                subBizTypesb: '',
                payMoney: '0',
                showModal: !1,
                showModal02: !1,
                showText: '开通',
            }
        },
        methods: {
            fatherModal() {
                let _this = this;
                _this.showModal = !1;
                _this.showModal02 = !1;
            },
            //更改按钮文案
            updatePayTxt() {
                this.showText = '续费'
            },
            goSy(money) {
                console.log('-----------------', money)
                let _this = this;
                // _this.getUserStaus();
                console.log("测试 222 ：start ");
                userInfo().then(res => {
                    if (res.code == 200) {
                        Cookies.set("userInfo", JSON.stringify(res.result));
                        this.setStore("userInfo", res.result);
                        // let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
                        let userInfo = res.result;
                        console.log("测试 222 ：获取状态的返回值 ", userInfo)


                        if (userInfo == '') {
                            toast('请登录后再操作')
                            return false;
                        }
                        if (userInfo.realNameStatus != 'complete_real_name') {
                            toast('请实名认证后再操作', function () {
                                _this.$router.push({
                                    path: '/authentication'
                                })
                            })
                            return false;
                        }
                        if (userInfo.vipFlag == '0' || userInfo.vipFlag == '2') {
                            //不是会员或者7天会员
                            this.$router.push({
                                name: "openVip",
                                query:{
                                    type:""
                                },
                            });
                            // this.showModal = !0;
                        } else {
                            //已经是会员
                            this.$router.push({
                                name: "openVip",
                                query:{
                                    type:money.title
                                },
                            });
                            // this.showModal02 = !0;
                        }

                        this.subBizTypesb = money.code
                        this.payMoney = money.value
                    }
                })
            },
            _goPersonOrEnterVip() {
                _findIndexPageShowNewNew().then(res => {
                    if (res.code == 200) {
                        this.vipList = []
                        let middleGv = res.result
                        for (let i = 0; i < middleGv.length; i++) {
                            // if(middleGv[i].accountScope=='person'){
                            this.vipList.push(middleGv[i])
                            // }
                        }
                    }
                    // debugger ;
                    let showKtList = this.vipList.slice(0, 3)
                    for (let j = 0; j < showKtList.length; j++) {
                        switch (j) {
                            case 0 :
                                showKtList[j].url = require('../../../assets/copper_vip_intro.png')
                                break;
                            case 1 :
                                showKtList[j].url = require('../../../assets/silver_vip_intro.png')
                                break;
                            case 2 :
                                showKtList[j].url = require('../../../assets/gold_vip_intro.png')
                                break;
                            default:
                                break;
                        }
                    }
                    this.showKtList = showKtList
                    // console.log('???????????????????',showKtList)
                })
            },
            pushDci() {
                this.$router.push({name: 'dciIntroduce'})
            },
            getUserStaus() {
                userInfo().then(res => {
                    if (res.code == 200) {
                        Cookies.set("userInfo", JSON.stringify(res.result));
                        this.setStore("userInfo", res.result);
                    }
                })
            }
        },
        created() {
            let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
            this.showText = userInfo == '' ? '开通' : userInfo.vipFlag == '0' || userInfo.vipFlag == '2' ? '开通' : '续费';
        },
        mounted() {
            this._goPersonOrEnterVip()
        }
    }
</script>
